import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  async componentDidMount() {
  }
  render() {
    return (
        <div id="appCapsule">
        <h1>Terms</h1>
        </div>
    );
  }
}
export default withRouter(Terms);
